export default "assets/images/icons/larger-dcbd4acb.svg";